import React from 'react';
import clsx from "clsx";
import {SignInForm} from "./components/form/SignInForm";
import {SignInSuccessInfo} from "./components/success-info/SignInSuccessInfo";
import BackgroundImage from "./components/background-image/BackgroundImage";
import {Link} from "react-router-dom";
import AppRouters from "application/globals/app-routers";
import {BackIcon} from "./components/back-icon";
import {useSignIn} from "./use-sign-in";

import styles from './sign-in.module.scss';

export const SignInPage = () => {
  const {isSubmitting, isLoading, onSubmit, email, onResetSignIn} = useSignIn();

  return (
    <div className={styles.container}>
      <div className={styles.backgroundImage}>
        <BackgroundImage/>
      </div>

      {
        !isSubmitting
          ? <SignInForm
            isLoading={isLoading}
            onSubmit={onSubmit}/>
          : <SignInSuccessInfo
            email={email}
            onResetSignIn={onResetSignIn}/>
      }

      <div className={"flex justify-center mt-10"}>
        <Link to={AppRouters.home} className={clsx("flex btn-clear p-3", styles.backButtonContainer)}>
          <BackIcon className="inline-icon"/>
          <span>Regresar al inicio</span>
        </Link>
      </div>
    </div>
  );
};
